import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs';
import { RaceTransformData } from 'src/app/helpers/RaceHelper';
import { environment } from 'src/environments/environment';

const { createClient, SupabaseClient } = require('@supabase/supabase-js');

import { v4 as uuidv4 } from 'uuid'; // UUID kütüphanesi

@Injectable({
  providedIn: 'root',
})
export class SupabaseService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  private supabase: typeof SupabaseClient;
  private publicSupabase: typeof SupabaseClient;

  constructor(private http: HttpClient) {
    this.supabase = createClient(
      environment.SUPABASE_URL,
      environment.SUPABASE_ANON_KEY
    );

    this.publicSupabase = createClient(
      environment.SUPABASE_URL,
      environment.SUPABASE_ANON_KEY
    );
  }

  performAction(
    actionType: 'public' | 'auth',
    action: (supabase: typeof SupabaseClient) => any
  ): Observable<any> | any {
    if (actionType === 'public') {
      const result = action(this.publicSupabase);
      return result;
    } else {
      this.getJWTokenForSupabase();
      const result = action(this.supabase); // Auth gerektiren işlemi token ile çağır
      return result;
    }
  }

  getJWTokenForSupabase(): Observable<any> {
    const url = environment.apiUrl + `/user/getSupabaseToken`;

    let supabaseToken = '';

    const jwtToken = this.http.get<any>(url, this.httpOptions);

    jwtToken.subscribe((res) => {
      const token = res.token;
      this.supabase['headers'].authorization = `Bearer ${token}`;
      this.supabase['realtime'].setAuth(token);
      supabaseToken = token;
    });

    return new Observable((observer) => {
      observer.next({ token: supabaseToken });
      observer.complete();
    });
  }

  getUserBalance(callback: (payload: any) => void, retryCount: number = 0) {
    if (retryCount > 3) {
      return null;
    }

    const walletOptions = {
      event: '*',
      schema: 'public',
      table: 'wallet',
    };

    return this.performAction('auth', (supabase) => {
      return supabase
        .channel('wallet_changes')
        .on('postgres_changes', walletOptions, (payload: any) => {
          callback(payload);
        })
        .subscribe((status: any) => {
          if (status === 'SUBSCRIBED') {
            console.log('status wallet', status);
          } else {
            return this.getUserBalance(callback, retryCount + 1);
          }
        });
    });
  }

  getRaceDetails(callback: (payload: any) => void, id: string) {
    const raceTrackSubOptions = {
      event: 'UPDATE',
      schema: 'public',
      table: 'race_track_sub',
      filter: `sub_id=eq.${id}`,
    };

    return this.performAction('public', (supabase) => {
      return supabase
        .channel('race_track_sub_changes')
        .on('postgres_changes', raceTrackSubOptions, (payload) => {
          const raceNewData = payload.new;
          const newData = RaceTransformData(raceNewData);
          callback(newData);
        })
        .subscribe((status: any) => {
          if (status === 'SUBSCRIBED') {
            console.log('status race details', status);
          } else {
            console.log('status race details', status);
          }
        });
    });
  }
}